import React, { useState, useContext } from 'react';
import Tooltip from "../Tooltip";
import { getConfigValue } from '../../util/getConfigValue';
import { AppContext } from '../../util/AppContext';

const ReportInfoTooltip = React.forwardRef(({text}, ref) => {
    const [showTooltip, setShowTooltip] = useState(false);
    const [appState, setAppState] = useContext(AppContext);

    return (
        <div className='ps-2'>
            <span
                ref={ref}
                onMouseOver={() => setShowTooltip(true)}
                onMouseOut={() => setShowTooltip(false)}
                className={getConfigValue(appState?.config?.UtilizationDashboard?.ToolTip?.Style, appState)?.Value || "fa-regular fa-circle-question color-white-d1"}
                style={{cursor: "default"}}
            ></span>

            <Tooltip
                text={text}
                ref={ref}
                showTooltip={showTooltip}
                modifiers={[
                    {
                        name: 'offset',
                        options: {
                            offset: [0, 15]
                        }
                    }
                ]}
            />
        </div>
    );
});

export default ReportInfoTooltip;